import React from 'react';
import Header from '../components/Header';
import Recipes from '../components/Recipes';
import Footer from '../components/Footer';

function Drinks() {
  return (
    <>
      <Header title="Drinks" />
      <Recipes />
      <Footer />
    </>
  );
}

export default Drinks;
